import {
  TEMPLATES_LOADING_START,
  TEMPLATES_LOADING_SUCCESS,
  TEMPLATES_LOADING_FAILED,
  CHANGE_TEMPLATES_PAGE,
  CHANGE_TEMPLATES_LIMIT,
} from '../actions/templatesList';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: false,
  loading: false,
  templates: [],
  total: 0,
  limit: 15,
  activePage: 1,
};

export default function (state = INITIAL_STATE, action) { 
  switch (action.type) {
    case TEMPLATES_LOADING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        templates: [],
        total: 0,
      };
    case TEMPLATES_LOADING_SUCCESS:
      return {
        ...state,
        ready: true,
        loading: false,
        templates: action.payload.templates.cards,
        total: parseInt(action.payload.templates.count, 10),
      };
    case TEMPLATES_LOADING_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    //Пагинация
    case CHANGE_TEMPLATES_PAGE:
      return {
        ...state,
        activePage: action.payload.activePage,
      };
    case CHANGE_TEMPLATES_LIMIT:
      return {
        ...state,
        limit: action.payload.activeLimit,
        activePage: INITIAL_STATE.activePage,
      };
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}